export default __webpack_public_path__ + "static/media/crystalcollector.f8fc27b1.jpg";